import React, { Component } from 'react';
import { UncontrolledCarousel } from 'reactstrap';
import ReactGA from 'react-ga';

export class Videos extends Component {
    constructor (props) {
        super(props);

        this.items = [
            {
              src: '/images/Back of postcard.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
              src: '/images/Beachfront Land.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
              src: '/images/Waterfront Land.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
              src: '/images/Stump Pass Aerial.jpg?w=1024&h=1024&mode=max', altText: '', caption: 'Stump Pass Aerial', header: ''
            },
            {
                src: '/images/Stump Pass Aerial 2.jpg?w=1024&h=1024&mode=max', altText: '', caption: 'Stump Pass Aerial', header: ''
            },
            {
              src: '/images/491 N Gulf Postcard Photo.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
              src: '/images/121 N Gulf Blvd..jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
                src: '/images/Palm Island Sunset.jpg?w=1024&h=1024&mode=max', altText: '', caption: 'Palm Island Sunset', header: ''
            },
            {
                src: '/images/Turtle.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
            {
                src: '/images/CMS_101919_3026.jpg?w=1024&h=1024&mode=max', altText: '', caption: '', header: ''
            },
        ];
    }

    componentDidMount() {
        ReactGA.set({ page: 'Videos' });
        ReactGA.pageview('/videos');
    }

  render () {
    return (
        <div className="container mb-5 pt-3">
            <div className="pt-4 text-center">
                <h4 className="d-inline-block ml-3" style={{color: '#333333'}}>Palm Island, Florida - Don Pedro Island, Southwest FL</h4>
            </div>
            <div className="embed-responsive embed-responsive-16by9">
                <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/NcrrZk964iU" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="Video"></iframe>
            </div>

            <div className="text-center mt-5">
                <h4>Island Photos</h4>
            </div>
            <div>
                <UncontrolledCarousel items={this.items} controls={true} slide={true} pause={'hover'} interval={5000} ></UncontrolledCarousel>
            </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Videos.jsx